import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthenticationBase } from '../../../Shared/service/Authentication';
import { MainNavigationBase } from '../../../Shared/service/MainNavigation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationReaderBase } from '../../../Shared/service/ConfigurationReader';
import { ClientSideUtility } from '../../../Shared/service/ClientSideUtility';
import { Report } from '../../../Shared/model/Report';
import { CommonServiceBase } from '../../../Shared/service/CommonService';
import {Observable} from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from '../../../../../node_modules/rxjs/operators';
import { Location } from '../../../../../node_modules/@angular/common';

declare let mLayout: any;
@Component({
selector: "app-aside-nav",
templateUrl: "./aside-nav.component.html",
encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit, OnDestroy {
    
    nextDayReports: Array<Report>;
    onDemandReports: Array<Report>;
    environment: string;
    showEnvironment: boolean;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    isAuthenticated: boolean;

    private ngUnsubscribe: Subject<boolean> = new Subject<boolean>();   
    
    constructor(private route: ActivatedRoute, private router: Router, private authenticationService: AuthenticationBase, 
                private navigationService: MainNavigationBase, private configurationReader: ConfigurationReaderBase,
                private clientSideUtility: ClientSideUtility, private commonService: CommonServiceBase)  {
    }

    ngOnInit(){
       
        let config = this.configurationReader.Configuration;
        this.showEnvironment = config.showEnvironment;
        this.environment = config.environment;
               
        if(this.authenticationService.isAuthenticated()){            
            this.isAuthenticated = true;
            this.buildMenu();
        }
        else
        {
            this.authenticationService.isAuthenticationCompleted()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((r) => {
                if ( r == true){    
                    this.isAuthenticated = true;                
                    this.buildMenu();
                }
            },
            (error:any)=> {            
                this.clientSideUtility.showAlertError("Error", error);
            });
        }
    }

    ngAfterViewInit(){
        mLayout.initAside();        
        this.clientSideUtility.resizeLeftSideNavigation();
        this.clientSideUtility.toggleEnvironment();
    }

    OnReportClick(reportId, reportUrl){
        this.router.navigate([reportUrl])
    }

    buildMenu():void{        

        this.commonService.getCurrentUserInfo()
        .subscribe(
            data=>{
                    this.isAdmin = data.isAdmin;   
                    this.isSuperAdmin = data.isSuperAdmin;                 
            },
            (error:any)=> {            
                this.clientSideUtility.showAlertError("Error", error);
            }
        );

        this.navigationService.GetReports()
        .subscribe(
            data=>{
                    this.nextDayReports = data.filter(f=>f.reportType == 'Scheduled');
                    this.onDemandReports = data.filter(f=>f.reportType == 'OnDemand');                    
            },
            (error:any)=> {            
                this.clientSideUtility.showAlertError("Error", error);
            }
        );
    }

    isReportsListAvailable(){
        return this.nextDayReports !=null && this.onDemandReports!=null;
    }

    goToUserManagement(): void{

        let config = this.configurationReader.Configuration;
        let userManagementUrl = config.idpURL + config.idpUserManagementUrl + config.idpClient;
        this.clientSideUtility.redirect(userManagementUrl);
    }

    goToOrganizationManagement(): void{

        let config = this.configurationReader.Configuration;
        let organizationUrl = config.idpURL + config.idpOrganizationUrl + config.idpClient;
        this.clientSideUtility.redirect(organizationUrl);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/theme/layouts/aside-nav/aside-nav.component.ts